import React from "react";
import CustomCardII from "./CardII";

const CardsStatus = ({ img, text1, text2, data1, data2, buttonTitle1="", buttonTitle2="", buttonIClassname="", buttonIIClassname="", buttonClick }) => {
  return (
    <div className="grid grid-cols-2 gap-0 border rounded-md shadow-md">
      <div className="border-r px-4 bg-red-50 pb-4">
        <div className="p-5 text-xl font-medium">{text1}</div>
        <div className="grid grid-cols-2 gap-4">
     {data1.length>0 && (<>
            {data1.map((item) => {
              return (
                <CustomCardII
                  image={img}
                  title={item?.equipment_name_code}
                  subtitleI={`${item?.equipment_type_name || ""}`}
                  subtitleII={item?.comp_location_name || ""}
                  clickFun={() => {
                    buttonClick({...item, img}, true);
                  }}
                  buttonTitle={buttonTitle1}
                  buttonClassName={buttonIClassname}
                />
              );
            })}
            </>
      )}
      </div>
      </div>

     <div className="px-4 pb-3 bg-green-50">
            <div className="p-5 text-xl font-medium">{text2}</div>
            <div className="grid grid-cols-2 gap-4">
            {data2.map((item) => {
              return (
                <CustomCardII
                  image={img}
                  title={item?.equipment_name_code}
                  subtitleI={`${item?.equipment_type_name || ""}`}
                  subtitleII={item?.comp_location_name || ""}
                  clickFun={() => {
                    buttonClick({...item, img}, false);
                  }}
                  buttonTitle={buttonTitle2}
                  buttonClassName={buttonIIClassname}
                  isEdit={true}
                  emission={item?.refrigerant?.co2_emission_tones ? item?.refrigerant?.co2_emission_tones : "--"}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CardsStatus;
